import { render } from "./Inspection.vue?vue&type=template&id=c51f3192&scoped=true"
import script from "./Inspection.vue?vue&type=script&lang=js"
export * from "./Inspection.vue?vue&type=script&lang=js"

import "./Inspection.vue?vue&type=style&index=0&id=c51f3192&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c51f3192"

export default script